<template>
  <v-container>
    <v-row class="text-left">Readonly link:</v-row>
      <span>{{ linkValue }}</span>

      <v-icon
            class="ml-3"
            v-clipboard:copy="linkValue"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError">{{ mdiContentCopy }}</v-icon>

      <v-tooltip
          right
          :open-on-hover=false
          v-model="showTooltip"
          >
            <template v-slot:activator="{ on }">
              <span v-on="on"> </span>
            </template>
            <span>Copied to clipboard!</span>
      </v-tooltip>

      <br />Anyone with this link can read the story.
      <social-sharing :url=linkValue
                        title="Add to the Story: Read a new story I wrote!"
                        description="Checkout a new story my friends and I wrote at AddToTheStory.com."
                        quote="Add to the Story lets any group of friends write their own choose your own adventure type story."
                        hashtags="addtothestory"
                        inline-template>

        <div class="title">
            <span class="blue--text">
            <network network="email" class="mr-2">
                <img alt="Email" src="../assets/email.svg">
            </network>
            <network network="facebook" class="mr-2">
              <img alt="Facebook logo" src="../assets/facebook.svg">
            </network>
            <network network="sms" class="mr-2">
              <img alt="SMS" src="../assets/message-processing-outline.svg">
            </network>
            <network network="twitter" class="mr-2">
              <img alt="Twitter" src="../assets/twitter.svg">
            </network>
            <network network="whatsapp" class="mr-2">
              <img alt="WhatsApp" src="../assets/whatsapp.svg">

            </network>
            </span>
        </div>
    </social-sharing>

    <v-row v-if="errtext" class="red--text">{{errtext}}</v-row>
  </v-container>
</template>

<script>
import { mdiContentCopy } from '@mdi/js'

export default {
  name: 'ReadOnlyLink',
  data: () => ({
    mdiContentCopy: mdiContentCopy,
    errtext: null,
    showTooltip: false
  }),
  computed: {
    linkValue () {
      return 'https://addtothestory.com/story/' + this.$route.params.storyID
    }
  },
  methods: {
    onCopy (value) {
      this.showTooltip = true
      window.setTimeout(() => {
        this.showTooltip = false
      }, 2000)
    },
    onError (value) {
      console.log('error', value)
      this.errtext = value
    }

  }
}
</script>
